module.exports = __webpack_public_path__ + "static/sorteio-21e9cc3475fcb94ca4e9d2b44533c604.jpg";